import { userRelations } from "@texts/users";
import React from "react";

function Family ({ clientInfo }) {

    return(
        <div>
           <strong>{"שיוך משפחתי: "}</strong>
            {clientInfo['parent_id'] && clientInfo['related_as'] ?
                <span>
                    {`${userRelations[clientInfo['related_as']]} של `}
                    <a
                        target="_blank"
                        style={{ textDecoration: 'underline', color: 'black' }}
                        href={`/clients/${clientInfo['parent_id']}`}
                    >
                        משתמש {clientInfo['parent_id']}
                    </a>
                </span> :
                '-'
            }
        </div>
    )
}

export default Family

